module.exports = __webpack_public_path__ + "img/knzb-main.982806ac.webp";